var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.history),function(item){return _c('p',{key:item.id},[_vm._v(" "+_vm._s(item.id)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }